import { ConfigProvider, Empty } from 'ant-design-vue';
import { applicationResource } from '@/views/customer/applicationManage/request';
import { insuranceResource } from '@/views/insurance/insuranceManage/request';
import { invoiceRecordList } from '../request';
import { mapState } from 'vuex';
export default {
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
  },
  components: {
    ConfigProvider
  },
  data() {
    return {
      form: {
        customerId: undefined,
        applicationId: undefined,
        insuranceId: undefined,
        invoiceStatus: undefined,
        searchField: undefined,
        searchValue: undefined
      },
      customerList: [],
      applicationList: [],
      productList: [],
      statusList: [{
        key: 'SUCCESS',
        name: '已开票'
      }, {
        key: 'INVOICING',
        name: '开票中'
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      noDataText: '暂无数据',
      data: [],
      columns: [],
      locale: {
        // 默认图片
        emptyText: () => {
          return `<div class="noDataText">${this.noDataText}</div>`;
        }
      },
      loading: false
    };
  },
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  created() {
    this.form.customerId = this.accountInfo.customerId;
    // 获取列表页-设置表头
    this.getListData();
    this.applicationFun();
  },
  mounted() {},
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    // 保单归属回调
    customerChange(val) {
      this.form.applicationId = undefined;
      this.form.insuranceId = undefined;
      this.form.customerId = val;
      sessionStorage.setItem('policyCustomerId', val);
      this.applicationFun();
    },
    // 保单来源
    applicationFun() {
      this.form.applicationId = undefined;
      this.form.insuranceId = undefined;
      applicationResource({
        customerId: this.form.customerId
      }).then(res => {
        this.applicationList = res;
      });
    },
    // 产品名称
    getInsuranceFun() {
      this.productList = [];
      this.form.insuranceId = undefined;
      if (!this.form.applicationId) {
        return false;
      }
      insuranceResource({
        applicationId: this.form.applicationId,
        customerId: this.form.customerId
      }).then(res => {
        this.productList = res;
      });
    },
    // 搜索
    searchFun() {
      this.data = [];
      this.pagination.current = 1;
      this.pagination.total = 0;
      this.getListData();
    },
    // 重置
    rest() {
      this.form.applicationId = undefined;
      this.form.insuranceId = undefined;
      this.form.invoiceStatus = undefined;
      this.form.searchField = undefined;
      this.form.searchValue = undefined;
    },
    async getListData() {
      this.loading = true;
      await invoiceRecordList({
        ...this.form,
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      }).then(res => {
        this.columns = res.fieldConfig;
        this.data = res.items;
        this.pagination.total = res !== null && res !== void 0 && res.totalNum ? res.totalNum : 0;
        this.loading = false;
      }).catch(err => {
        this.data = [];
        this.pagination.current = 1;
        this.pagination.total = 0;
        this.loading = false;
      });
    },
    tablePageChange(val) {
      this.pagination = val;
      this.getListData();
    }
  }
};